import { FormControl, MenuItem } from "@mui/material";
import { Controller } from "react-hook-form";
import { CustomStyledTextField } from "./ColoredTextfield";
import { useEffect } from "react";
import dropdownicon from "../assets/images/dropdownicon.svg";

export function AgMuiSelect2({name,options,values,disableUnderline,disabled,onChangeHandler,backgroundColor,rules,iconColor,showIconBorder=true, fontSize,fontColor, width="max-content" ,size,style,control,padding,error,...restProps}) {
    return  (
      <FormControl sx={{width:width}}>
         <Controller
          name={name} // Specify the name for the form field
          control={control} // Pass the control prop from useForm
          rules={rules}
          render={({ field , fieldState }) => (
            <CustomStyledTextField 
            {...field}
            onChange={(e)=>{
                if(onChangeHandler){
                    onChangeHandler(e.target.value)
                }
                // console.log("this after if condition ")
                field.onChange(e);  
            }}
            fullWidth error={!!fieldState.error} helperText={fieldState?.error?.message}   InputProps={{
                disableUnderline,
                style: {
                  width:width?width:"170px",
                    fontSize : fontSize || "16px",
                    color: fontColor || "black",
                    backgroundColor: backgroundColor || "white",
                    // textAlign:"center",
                    // alignItems:"center",
                    ...style
                }
            }} 
            
            sx={{
                maxWidth: width || "90px",
                "& .MuiSelect-select" : {
                    padding : padding 
                },
                '& .MuiSelect-icon': {
                    color: iconColor || "inherit",
                },
                "& .MuiOutlinedInput-root": {
                    padding : "0px !important",
                    "&.Mui-focused": {
                      fieldset: {
                        borderColor: `${process.env.REACT_APP_ENTERPRISE_COLOUR} !important`, // Default focused color
                      },
                    },
                    "&.Mui-error": {
                      "&.Mui-focused": {
                        fieldset: {
                          borderColor: 'red !important', // Color for focused and error state
                        },
                      },
                    },
                  },
            }} size={size || "small"} {...restProps}  select disabled={disabled}
            >
                {options?.map((option,i) => <MenuItem value={ values?.length>0 ? values[i] : option}>{option}</MenuItem>)}
            </CustomStyledTextField>

          )}
        />
 </FormControl>
    );
  }
  